import { Component, OnInit } from '@angular/core';
import { EntidadesService } from 'src/app/services/entidades.service';
import { esResponsive, isMobile } from '../utils/utils';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  estadoContenedor:boolean = false;
  posicionTop:string="";
  seccionUnoHeight:any;
  esResponsive=esResponsive;
  estadosMenuEntidades:any = [];
  ultimoActivo:any = {pos:0,estado:false};
  heightMenuContraido = 90;
  estadoEventoScroll:boolean=true;
  estadoEventoClick:boolean=false;
  estadoResize:boolean=true;
  estadoBanner:boolean=true;
  estiloFijo:any = {position:'fixed',top:this.posicionTop, height:'90px'};
  parametroBuscador = '';
  objeto:any;
  tituloPrimeraSeccion:any;
  constructor(private serviceEntidades:EntidadesService) {
  }

  ngOnInit() {
    this.getEntidades();
    this.getTituloPrimeraSeccion();
  }

  ngAfterViewInit(){
    var obj = this;
    window.addEventListener("scroll" ,function(e) {
      if(e.type !== 'scroll'){
        return;
      }
      obj.activarDesacticarMenuCollapse();
      if(obj.estadoEventoScroll && !obj.estadoEventoClick){
        obj.activarDesacticarItemsMenuCollapse();
      }
    });
  
    window.scrollTo(0,0)
  }

  getEntidades(){
    this.serviceEntidades.getEntidades().subscribe((resp) => {
      if(resp.data){
          this.objeto = resp.data;
          setTimeout(() => {
            this.seccionUnoHeight = document.getElementById("seccion-uno").clientHeight;
          }, 500);
      }
    });
  }

  getTituloPrimeraSeccion(){
    this.serviceEntidades.getTituloPrimeraSeccion().subscribe((resp) => {
      if(resp.data){
          this.tituloPrimeraSeccion = resp.data.nombre;
      }
    });
  }

  activarDesacticarMenuCollapse(){
    var seccion = document.getElementById("seccion_"+this.objeto[0].tituloAlternativo);
    if(!this.esResponsive()){
      if(this.esVisibleSeccion(seccion)){
        seccion.style.marginTop = this.seccionUnoHeight+"px";
        var box = document.getElementById('govco-header');
        this.posicionTop=box.offsetHeight+"px";
        this.estadoContenedor=true;
        this.estiloFijo = {position:'fixed',top:this.posicionTop, height:'90px'};
      }else{
        seccion.style.marginTop = "0px";
        this.estadoContenedor=false;
      }
    }else{
      seccion.style.marginTop = "0px";
      this.estadoContenedor=false;
    }
  }

  activarDesacticarItemsMenuCollapse(){
    if(this.estadoContenedor){
      var seccionMenu = document.getElementById("seccion-uno");
      var seccionMenuScrollTop = seccionMenu.getBoundingClientRect().top;
      var seccionMenuScrollBottom = seccionMenuScrollTop+seccionMenu.clientHeight;
      var fueraSeccionEntidades = false;
      this.objeto.map(function(rama) {
        if(!rama || !rama.tituloAlternativo) return;
        var seccionEntidad = document.getElementById("seccion_"+rama.tituloAlternativo);
        var seccionEntidadScrollTop = seccionEntidad.getBoundingClientRect().top-seccionMenu.clientHeight;
        var seccionEntidadScrollBottom = seccionEntidadScrollTop+seccionEntidad.clientHeight+seccionMenu.clientHeight;

        if(seccionEntidadScrollTop<seccionMenuScrollTop && seccionEntidadScrollBottom>seccionMenuScrollBottom){
          
          document.getElementById("item_menu_"+rama.tituloAlternativo).classList.add("activo");
          fueraSeccionEntidades = true;
        }else{
          // console.log("Afuera "+rama.tituloAlternativo+"->"+seccionEntidadScrollTop +" < "+ seccionMenuScrollTop + " | " +seccionEntidadScrollBottom + ">" + seccionMenuScrollBottom)
          document.getElementById("item_menu_"+rama.tituloAlternativo).classList.remove("activo");
        }
      });
    }
  }

  esVisibleSeccion(elem){
    let elementScrollTop = elem.getBoundingClientRect().top;
    var box = document.getElementById('govco-header');
    return box?(elementScrollTop<=box.offsetHeight+this.heightMenuContraido):false;
  }

  arrasteASeccion(link,id){
    this.estadoEventoClick=true;
    var box = document.getElementById('govco-header');
    var scrollTop = document.getElementById('seccion_'+id).style["scrollMarginTop"]="0px"
    this.esResponsive() && !this.isHeaderFixed()?scrollTop:document.getElementById('seccion_'+id).style["scrollMarginTop"] = (box.offsetHeight+(this.esResponsive()?0:this.heightMenuContraido)-5)+"px";
    document.getElementById("seccion_"+id).focus();

    setTimeout(() => {
      document.getElementById('seccion_'+id).scrollIntoView();
    }, 100);

    this.esResponsive()?null:document.querySelectorAll(".items-menu").forEach(function(item,index){
      item.classList.remove("activo");
    });
    this.esResponsive()?null:document.getElementById('item_menu_'+id).classList.add("activo")
    setTimeout(() => {
      this.estadoEventoClick=false;
    }, 1000);
  }

  isHeaderFixed() {
    if (!isMobile()) {
      if (window.devicePixelRatio > 1.75) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  construirMenuEstadosEstidades(){
    var obj = this;
    this.objeto.map(function(rama) {
      obj.estadosMenuEntidades["item_menu_"+rama.tituloAlternativo]=false;
    });
  }


  cerrarVentana(evt){
    this.estadoBanner=!this.estadoBanner;
  }

  activarEventosAccesibilidad(evt){
    if(evt.keyCode==9){
        window["objeto"]=this;
        window.addEventListener('keyup',this.setEventos);
        window.addEventListener('keypress',this.setEventos);
    }else if(evt.keyCode==27){
      document.getElementById("salir-seccion-entidades").focus();
    }
  }

  desActivarEventosAccesibilidad(evt){
    if(evt.keyCode==9){
      window.removeEventListener('keyup', this.setEventos);
      window.removeEventListener('keypress', this.setEventos);
    }
  }

  setEventos(evt){
    if(evt.key==="Escape"){
      window.removeEventListener('keyup', window["objeto"].setEventos);
      document.getElementById("salir-seccion-entidades").focus();
    }
    if(evt.code==="Space"){
      document.getElementById("listado-noticias").focus();
    }
  }

  setFocusGrupoNoticias(){
    setTimeout(() => {
      document.getElementById("contenedor-noticias-focus").focus();
      window.scrollTo(0, 300);
    }, 1000);
  }
}
